// Carteira de jogos (moedas ↔ Blue Coins) — liga o widget game-wallet.js ao Gold Miner.
// Com a carteira ligada a jogada é paga em Blue Coins (users.game_coins) e o prêmio
// continua sendo PRESENTE. O saldo da tela vem do widget (troca) e do `newCoins` da
// jogada (o débito no servidor é assíncrono: o newCoins é a verdade logo após jogar).
import { useEffect, useState } from 'react'
import '../commom/game-wallet.js'

const API = import.meta.env.VITE_API_ENDPOINT as string

export type WalletView = { enabled: boolean; gameCoins: number; ready: boolean }

let startAsked = false

export function useGameWallet(): WalletView & { setGameCoins: (n: number) => void } {
  const [w, setW] = useState<WalletView>({ enabled: false, gameCoins: 0, ready: false })
  useEffect(() => {
    const token =
      new URLSearchParams(location.search).get('token')?.trim() ||
      window.localStorage.getItem('@token') ||
      ''
    if (!token) {
      setW((p) => ({ ...p, ready: true }))
      return
    }
    const gw = window.GameWallet
    const off = gw.onChange((s) => setW({ enabled: s.enabled, gameCoins: s.gameCoins, ready: true }))
    gw.init({ apiUrl: API, token, autoOpenWhenEmpty: false }).then((s) => {
      setW({ enabled: s.enabled, gameCoins: s.gameCoins, ready: true })
      // entrou com 0 Blue Coins: aviso Sim/Não (Sim → carteira na aba Colocar; Não → sai)
      if (s.enabled && s.gameCoins <= 0 && !startAsked) {
        startAsked = true
        gw.ask('start')
      }
    })
    return off
  }, [])
  return { ...w, setGameCoins: (n: number) => setW((p) => ({ ...p, gameCoins: n })) }
}

/** Erros/status que, com a carteira ligada, querem dizer "sem Blue Coins". */
export const NO_COINS = ['not_found_coins', 'not_coins', 'insufficient_coins', 'insufficient_balance']
